import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Escape a string for use inside a `RegExp` source (same behavior as lodash `escapeRegExp`). */
export function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * Normalize path for API requests by removing bucket prefixes.
 * Finds "apps/" in the path and removes everything before it.
 * API expects paths starting with "apps/"
 */
export function normalizePathForApi(path: string): string {
  // Find "apps/" in the path and remove everything before it
  const appsIndex = path.indexOf('apps/')
  if (appsIndex !== -1) {
    return path.slice(appsIndex)
  }
  // If "apps/" not found, return path as-is (shouldn't happen in normal cases)
  return path
}
